import React, { useState, useEffect } from 'react'
import '../../App.css'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { formatZARCurrency } from '../../MoneyFormat'
import { API_URL } from '../../config'
// import "./PayoutRequestList.css"; // Optional styling

const PayoutRequestList = ({ eventid, count, setRefreshing, source }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [requests, setRequests] = useState([])
  const [clipLoading, setClipLoading] = useState(true)
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const sitURL = API_URL

  // let query = "";
  // if (source === "partnerPayout") {
  //   query = "PAYOUT-REQUEST-LIST-PARTNERS";
  // } else {
  //   query = "PAYOUT-REQUEST-LIST";
  // }
  useEffect(() => {
    Axios.get(`${baseURL}?query=PAYOUT-REQUEST-LIST&event_id=${eventid}`, {
      withCredentials: true,
    }).then((response) => {
      setRefreshing('')
      setClipLoading(false)
      const res = response.data
      console.log(res.length)
      if (res.length === 0) {
        setRequests([])
      } else {
        setRequests(res)
      }
    })
  }, [count])

  const totalRequested = requests.reduce((sum, req) => {
    return sum + parseFloat(req.amount_requested)
  }, 0)

  return (
    <div className="accordion-item">
      <h5
        onClick={() => setIsOpen(!isOpen)}
        className="accordion-header me-auto text-bold text-dark cursor-pointer"
      >
        Payout Request History {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        <br />
        <label className="text-15 font-normal">View payout history — pending and paid.</label>
      </h5>
      {isOpen && (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Payout Type</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Reference ID</th>
                <th>Proof of Payment</th>
              </tr>
            </thead>
            <tbody>
              {clipLoading ? (
                <tr>
                  <td colSpan={6} className="text-center">
                    <ClipLoader size={25} color="grey" />
                  </td>
                </tr>
              ) : (
                <>
                  {requests.length === 0 ? (
                    <tr>
                      <td colSpan={6}>No payout requests found.</td>
                    </tr>
                  ) : (
                    <>
                      {requests.map((req) => (
                        <tr key={req.payout_id}>
                          <td>{new Date(req.created_at).toLocaleDateString()}</td>
                          <td>{req.payout_type}</td>
                          <td>{formatZARCurrency(req.amount_requested.toString())}</td>
                          <td>
                            <label className={`status-badge`}>{req.payout_status}</label>
                          </td>
                          <td>{req.audit_token}</td>
                          <td>
                            {!req.file_url ? (
                              <label className="font-medium">Pending</label>
                            ) : (
                              <a
                                href={`${sitURL}/apps/kscanner/payments/${req.eventId}/${req.file_url}`}
                                target="_blank"
                                className="color-blue"
                              >
                                {req.file_url}
                              </a>
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={6} className="text-right">
                          <span>Total:</span> {formatZARCurrency(totalRequested.toString())}
                        </td>
                      </tr>
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default PayoutRequestList
